import Client from "../client";
import Vendor from "@/entities/vendor";
import VendorGateway from "@/usecases/gateways/vendor-gateway";
import { client } from "../request";

export default class VendorApi implements VendorGateway {
  public constructor(private client: Client) {}

  /**
   * 業者の一覧を得る
   */
  public async findByProjectId(projectId: number): Promise<Vendor[]> {
    const params = { projectId };
    const res = await this.client.get("get_all_vendors_private.php", params);
    return res.vendorList.map(toVendor);
  }
}

function toVendor(data: any): Vendor {
  return {
    id: getVendorId(data),
    name: getVendorName(data),
    workTypeIds: data.workTypeIds || []
  };
}

function getVendorId(data: any): number {
  return (data.office && data.office.officeId) || 0;
}

function getVendorName(data: any): string {
  const companyName = (data.company && data.company.name) || "";
  const officeName = (data.office && data.office.name) || "";
  return `${companyName} ${officeName}`;
}

interface GetProjectVendorsQuery {
  projectId: number;
}

/**
 * 現場の業種の一覧を得る
 */
export async function getProjectVendors({
  projectId
}: GetProjectVendorsQuery): Promise<Vendor[]> {
  return await new VendorApi(client).findByProjectId(projectId);
}
